import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BigQueryAuthInterceptor } from './bigquery-auth.interceptor';
import { GoogleCloudTokenExchangeService } from './google-cloud-token-exchange.service';

export function provideBigQueryAuthInterceptor() {
  return [
    GoogleCloudTokenExchangeService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BigQueryAuthInterceptor,
      multi: true,
    },
  ];
}
